import React from 'react';
import PropTypes from 'prop-types';
import ModalWindow from '../../common/Modal';
import Button from '../../common/Button';
import styles from './IntegrationGoogleModal.module.scss';

function IntegrationGoogleModal(props) {
  const { onClose, open = false } = props;

  const submit = (e) => {
    props.submit();
    onClose();

    e.preventDefault();
  };

  return (
    <ModalWindow open={open} onClose={onClose} center>
      <form className={styles.form} onSubmit={submit}>
        <h2>Connect your Google Account</h2>

        <hr />

        <p>
          You must be eligible for
          <strong>
            {' '}
            <a
              href="https://support.google.com/merchants/answer/7679273?hl=en"
              target="_blank"
              rel="noopener noreferrer"
            >
              Shopping Actions
            </a>{' '}
          </strong>
          program.
        </p>
        <p>
          You will be redirect to Google to allow Cymbio to access your <strong>Google Shopping</strong> account.
        </p>

        <hr />

        <div className={styles.footer}>
          <div className={styles.button}>
            <Button type="submit" text="OK" />
          </div>
        </div>
      </form>
    </ModalWindow>
  );
}

export default IntegrationGoogleModal;

IntegrationGoogleModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  submit: PropTypes.func.isRequired,
};
